import { useQueryClient } from '@tanstack/vue-query'

import { useTokenManager } from '@/utils/authorization/token-manager'
import { maLogger } from '@/base/logger'
import { RouteName } from '@/base/constants/route'
import { accountQueryKey, fetchUserInfo } from '@/api/services/account'

export async function maAuthenticationGuard(to, from, next) {
  const queryClient = useQueryClient()
  const { logoutAndCleanup } = useTokenManager()

  const matchedRouteNames = to.matched.map(({ name }) => name)

  try {
    const user = await queryClient.ensureQueryData({
      queryKey: accountQueryKey.fetchUserInfo(),
      queryFn: fetchUserInfo,
    })

    if (!user.emailVerified) {
      maLogger.warn('[maAuthenticationGuard] Not verified e-mail, redirect to e-mail verification page')
      return next({ name: RouteName.AUTH_REGISTER_SUCCESS })
    }

    if (!user.onboardingCompleted && !matchedRouteNames.includes(RouteName.ONBOARDING)) {
      maLogger.warn('[maAuthenticationGuard] Onboarding not completed, redirect to onboarding')
      return next({ name: RouteName.ONBOARDING })
    }

    next()
  }
  catch (e) {
    maLogger.warn('[maAuthenticationGuard] Failed to load user info:', e)
    next(false)
    await logoutAndCleanup()
  }
}
